import { RootState } from '@reducers/index';
import { tagTypes } from 'lib/src/shared/enums/tagTypes';
import { ChallengeTag } from 'lib/src/types/shared/ChallengeTag';

export const getChallengeTags = (state: RootState): Record<number, ChallengeTag> =>
    Object.values(state.challengeTagsReducer.challengeTags).filter(
        ({ type }) => type === tagTypes.tag,
    );
export const getBusinessTags = (state: RootState): Record<number, ChallengeTag> =>
    Object.values(state.challengeTagsReducer.challengeTags).filter(
        ({ type }) => type === tagTypes.business,
    );

export const getTag = (state: RootState, id: number): ChallengeTag =>
    state.challengeTagsReducer.challengeTags[id] ?? ({} as ChallengeTag);
export const getChallengeTagsIsFetching = (state: RootState): boolean =>
    state.challengeTagsReducer.isFetching;
export const getChallengeTagsFetchError = (state: RootState): string | null =>
    state.challengeTagsReducer.fetchError;
export const getChallengeTagsIsPosting = (state: RootState): boolean =>
    state.challengeTagsReducer.isPosting;
export const getChallengeTagsPostSuccess = (state: RootState): boolean =>
    state.challengeTagsReducer.postSuccess;
export const getChallengeTagsPostError = (state: RootState): string | null =>
    state.challengeTagsReducer.postError;
export const getChallengeTagsIsDeleting = (state: RootState): boolean =>
    state.challengeTagsReducer.isDeleting;
export const getChallengeTagsDeleteError = (state: RootState): string | null =>
    state.challengeTagsReducer.deleteError;
export const getChallengeTagsDeleteSuccess = (state: RootState): boolean =>
    state.challengeTagsReducer.deleteSuccess;
